const MOBILE_DEVICE_DIMENSIONS = {
  small_phone: {
    name: 'Small Phone',
    viewport_width: 320,
    viewport_height: 568,
    pixel_ratio: 2,
    screen_width: 640,
    screen_height: 1136,
    scale: 1,
  },
  medium_phone: {
    name: 'Medium Phone',
    viewport_width: 375,
    viewport_height: 812,
    pixel_ratio: 3,
    screen_width: 1125,
    screen_height: 2436,
    scale: 1,
  },
  large_phone: {
    name: 'Large Phone',
    viewport_width: 414,
    viewport_height: 896,
    pixel_ratio: 3,
    screen_width: 1242,
    screen_height: 2688,
    scale: 1,
  },
  foldable: {
    name: 'Foldable',
    viewport_width: 928,
    viewport_height: 1080,
    pixel_ratio: 2,
    screen_width: 1856,
    screen_height: 2160,
    scale: 0.75,
  },
};

const REFERRALS_IMAGES = {
  small_phone: {
    name: 'iPhone_SE_Referrals.png',
    alt: 'iPhone_SE (1st gen)',
    iframeStyle: { top: 147, spacing: 148 },
  },
  medium_phone: {
    name: 'iPhone_X_Referrals.png',
    alt: 'iPhone X',
    iframeStyle: { top: 171, spacing: 207 },
  },
  large_phone: {
    name: 'iPhone_11_Pro_Max_Referrals.png',
    alt: 'iPhone 11 Pro Max',
    iframeStyle: { top: 171, spacing: 207 },
  },
  foldable: {
    name: 'Galaxy_Z_Fold_Referrals.png',
    alt: 'Galaxy Z Fold 6',
    iframeStyle: { top: 34, spacing: -18 },
  },
};

const POPUP_MESSAGES_IMAGES = {
  small_phone: {
    name: 'iPhone_SE_Popup.png',
    alt: 'iPhone_SE (1st gen)',
    iframeStyle: { top: 78, spacing: 286 },
  },
  medium_phone: {
    name: 'iPhone_X_Popup.png',
    alt: 'iPhone X',
    iframeStyle: { top: 142, spacing: 408 },
  },
  large_phone: {
    name: 'iPhone_11_Pro_Max_Popup.png',
    alt: 'iPhone 11 Pro Max',
    iframeStyle: { top: 163, spacing: 450 },
  },
  foldable: {
    name: 'Galaxy_Z_Fold_Popup.png',
    alt: 'Galaxy Z Fold 6',
    iframeStyle: { top: 91, spacing: 303 },
  },
};

const NOTIFICATION_IMAGES = {
  small_phone: {
    name: 'iPhone_SE_Notification.png',
    alt: 'iPhone_SE (1st gen)',
    titleStyle: { top: 104, maxWidth: 232, minWidth: 232 },
    iframeStyle: { top: 183, spacing: 237 },
  },
  medium_phone: {
    name: 'iPhone_X_Notification.png',
    alt: 'iPhone X',
    titleStyle: { top: 128, maxWidth: 288, minWidth: 288 },
    iframeStyle: { top: 208, spacing: 290 },
  },
  large_phone: {
    name: 'iPhone_11_Pro_Max_Notification.png',
    alt: 'iPhone 11 Pro Max',
    titleStyle: { top: 128, maxWidth: 328, minWidth: 328 },
    iframeStyle: { top: 208, spacing: 290 },
  },
  foldable: {
    name: 'Galaxy_Z_Fold_Notification.png',
    alt: 'Galaxy Z Fold 6',
    titleStyle: { top: 91, maxWidth: 840, minWidth: 840, left: -105 },
    iframeStyle: { top: 68, spacing: 60 },
  },
};

export { MOBILE_DEVICE_DIMENSIONS, REFERRALS_IMAGES, POPUP_MESSAGES_IMAGES, NOTIFICATION_IMAGES };
